
export const createTake = <T,>(data: T[], problemCount: number): T[] =>
  data
    .map((e) => [e, Math.random()] as [T, number])
    .sort((a, b) => a[1] - b[1])
    .map((e) => e[0])
    .slice(0, problemCount);
